import React from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";

import calculateCompleteness from "../utils/CompletenessCalculator";

Status.propTypes = {
    product: PropTypes.object
};

function Status({product}) {
    const validFieldsCountPercentage = calculateCompleteness(product);

    switch (true) {
        case validFieldsCountPercentage < 50:
            return <Badge rounded color={'warning'}>À enrichir</Badge>
        case validFieldsCountPercentage < 75:
            return <Badge rounded>Proposé</Badge>
        default:
            return <Badge rounded color={'online'}>Enrichi</Badge>
    }
}

export default Status;
